<template>
  <div>
    <van-popup v-model="show" position="right" style="width:100%;">
      <div class="bg-white popup-box">
        <section class="container-footer">
          <div class="popup-del" @click="show=false">
            <span class="icon icon-chacha f18"></span>
          </div>
          <div class="home-per">
            <van-collapse v-model="activeNames" class="perfect">
              <!-- <van-collapse-item name="0">
                <div slot="title"><span class="f12">区域</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround" :class="{'selected':contractAddressList.indexOf(item)>-1}"
                     v-for="(item,index) in areaList" :key="index"
                     @click="onCheck(item,'contractAddressList')">
                    <span class="block txt-elips">{{item}}</span>
                  </p>
                </div>
              </van-collapse-item> -->
              <van-collapse-item name="0">
                <div slot="title"><span class="f12">行业类型</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround"
                     :class="{'selected':positionClassTypeSysNoList.indexOf(item.CategorySysNo)>-1}"
                     v-for="(item,index) in cateList" :key="index"
                     @click="onCheck(item.CategorySysNo,'positionClassTypeSysNoList')">
                    <span class="block txt-elips">{{item.CategoryName}}</span>
                  </p>
                </div>
              </van-collapse-item>
              <van-collapse-item name="1">
                <div slot="title"><span class="f12">面试时间</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround"
                     :class="{'selected':timeSysNoList.indexOf(item.label)>-1}"
                     v-for="(item,index) in timeList" :key="index"
                     @click="onCheck(item.label,'timeSysNoList');onCheck(item.weekday,'weekdayList');">
                    <span class="block txt-elips">{{item.label}}</span>
                  </p>
                </div>
              </van-collapse-item>
              <!-- <van-collapse-item name="2">
                <div slot="title"><span class="f12">职业性质</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround" :class="{'selected':positionTypeList.indexOf(key)>-1}"
                     v-for="(item,key) in positionTypes"
                     :key="item" @click="onCheck(key,'positionTypeList')">
                    <span class="block txt-elips">{{item}}</span>
                  </p>
                </div>
              </van-collapse-item>-->
              <van-collapse-item name="2" v-if="pickStatus === 0">
                <div slot="title"><span class="f12">班次要求</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround" :class="{'selected':workTimeTypeList.indexOf(key)>-1}"
                     v-for="(item,key) in workTimes" :key="item"
                     @click="onCheck(key,'workTimeTypeList')">
                    <span class="block txt-elips">{{item}}</span>
                  </p>
                </div>
              </van-collapse-item>
              <van-collapse-item name="3">
                <div slot="title"><span class="f12">经验要求</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround" :class="{'selected':experienceList.indexOf(key)>-1}"
                     v-for="(item,key) in experiences" :key="item"
                     @click="onCheck(key,'experienceList')">
                    <span class="block txt-elips">{{item}}</span>
                  </p>
                </div>
              </van-collapse-item>
              <van-collapse-item name="4">
                <div slot="title"><span class="f12">年龄要求</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround" :class="{'selected':ageList.indexOf(key)>-1}"
                     v-for="(item,key) in ageType" :key="item"
                     @click="onCheck(key,'ageList')">
                    <span class="block txt-elips">{{item}}</span>
                  </p>
                </div>
              </van-collapse-item>
              <van-collapse-item name="5">
                <div slot="title"><span class="f12">性别要求</span></div>
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround" :class="{'selected':userGenderList.indexOf(1)>-1}"
                     @click="onCheck(1,'userGenderList')">
                    <span class="block txt-elips">男性</span>
                  </p>
                  <p class="van-bor1 van-hairline--surround" :class="{'selected':userGenderList.indexOf(2)>-1}"
                     @click="onCheck(2,'userGenderList')">
                    <span class="block txt-elips">女性</span>
                  </p>
                </div>
              </van-collapse-item>
              <div class="drawline van-hairline--top"></div>
              <van-cell title="福利待遇" value="全部" is-link @click="$refs.welfarePopup.show=true"/>
              <van-cell class="fringe pt0">
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround"
                     :class="{'selected':positionTagClassNameList.indexOf(item)>-1}"
                     v-for="item in tagClassNameList" :key="item"
                     @click="onCheck(item,'positionTagClassNameList')">
                    <span class="block txt-elips">{{item}}</span>
                  </p>
                </div>
              </van-cell>
              <div class="drawline van-hairline--top"></div>
              <van-cell title="岗位" value="全部" is-link @click="$refs.filterPositionClassPopup.show=true;show=false;"/>
              <!-- <van-cell title="岗位" value="全部" is-link @click="callPositionPopup"/> -->
              <van-cell class="fringe pt0">
                <div class="ds-partime-list clearfix">
                  <p class="van-bor1 van-hairline--surround"
                     :class="{'selected':positionClassNameList.indexOf(item)>-1}"
                     v-for="item in classNameList" :key="item"
                     @click="onCheck(item, 'positionClassNameList')">
                    <span class="block txt-elips">{{item}}</span>
                  </p>
                </div>
              </van-cell>
            </van-collapse>
          </div>
        </section>
      </div>
      <footer class="footer-fixed flex all-c">
        <van-button block type="default" class="flex-1 radius-0" @click="clear">
          <span class="f16 c-orange">重置</span>
        </van-button>
        <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="doSearch">
          <span class="f16">确定</span>
        </van-button>
      </footer>
    </van-popup>
    <welfare-popup ref="welfarePopup" :defaultList="positionTagClassNameList" :defaultIdList="positionTagIdList" @sure="setWelfare"></welfare-popup>
    <filter-position-class-popup ref="filterPositionClassPopup" :enterType=2 @search="search"></filter-position-class-popup>
  </div>
</template>
<script>
  import welfarePopup from '../welfare-popup';
  import filterPositionClassPopup from '../filter-positionclass-popup';
  import { getInterviewDateFilter } from '../../../libs/util';

  const { areaList, WorkTimeType, ExperienceAge, PositionTypes, GenderTypes, AgeType } = require('../../../libs/config');

  export default {
    components: { welfarePopup, filterPositionClassPopup },
    data() {
      return {
        show: false,
        pickStatus: 0,
        areaList: areaList.filter(v => v !== '任意区域'),
        workTimes: WorkTimeType,
        experiences: ExperienceAge,
        positionTypes: PositionTypes,
        genderTypes: GenderTypes,
        ageType: AgeType,
        userGenderName: '',
        showFilter: false,
        activeNames: ['0', '1', '2', '3', '4', '5', '6'],
        cateList: [],
        tagClassNameList: [],
        contractAddressList: [],
        positionTypeList: [],
        experienceList: [],
        workTimeTypeList: [],
        positionClassSysNoList: [],
        positionClassTypeSysNoList: [],
        positionTagClassNameList: [],
        positionTagIdList: [],
        ageList: [],
        userGenderList: [],
        timeSysNoList: [],
        weekdayList: [],
        timeList: [],
        classNameList: [], // 显示用
        positionClassNameList: [],
        positionClassSynNoList: [],
        selectPositionIdList: []
      };
    },
    mounted() {
      this.timeList = getInterviewDateFilter();
    },
    methods: {
      onCheck(item, key) {
        const index = this[key].indexOf(item);
        if (index > -1) {
          this[key].splice(index, 1);
        } else {
          this[key].push(item);
        }
      },
      clear() {
        this.contractAddressList = [];
        this.positionTypeList = [];
        this.experienceList = [];
        this.workTimeTypeList = [];
        this.positionClassSysNoList = [];
        this.positionTagClassNameList = [];
        this.positionTagIdList = [];
        this.ageList = [];
        this.userGenderList = [];
        this.timeSysNoList = [];
        this.weekdayList = [];
        this.classNameList = []; // 显示用
        this.positionClassNameList = [];
        this.positionClassSynNoList = [];
        this.selectPositionIdList = [];
        this.positionClassTypeSysNoList = [];
      },
      doSearch() {
        let ageList = this.ageList.map(item => {
          let arr = item.split('-');
          return { AgeMin: arr[0], AgeMax: arr[1] };
        });
        // 行业类型 -> 展开为该行业下的真实岗位ID（gwId），不能直接传行业序号
        let pcts = [];
        this.positionClassTypeSysNoList.forEach((sysNo) => {
          const industry = this.cateList.find((c) => String(c.CategorySysNo) === String(sysNo));
          if (industry && Array.isArray(industry.Categorys)) {
            pcts.push(...industry.Categorys.map((c) => c.CategorySysNo));
          }
        });
        this.positionClassSysNoList = [];
        if (this.positionClassNameList && this.positionClassNameList.length > 0) {
          this.selectPositionIdList = [];
          this.positionClassNameList.forEach(c => {
              const index = this.classNameList.indexOf(c);
              if (index > -1) {
                this.selectPositionIdList.push(this.positionClassSynNoList[index]);
              }
          });
          pcts = [...pcts, ...this.selectPositionIdList];
        }
        this.userGenderName = '';
        if (this.userGenderList.length === 2) {
          this.userGenderName = '不限';
        } else if (this.userGenderList.length === 1 && this.userGenderList[0] === 1) {
          this.userGenderName = '男性';
        } else if (this.userGenderList.length === 1 && this.userGenderList[0] === 2) {
          this.userGenderName = '女性';
        } else {
          this.userGenderName = '不限';
        }
        let showInterviewTimeStr = '';
        for (let index = 0; index < this.timeList.length; index++) {
          // console.log(this.timeList[index].label);
          if (this.timeSysNoList.indexOf(this.timeList[index].label) >= 0) {
            showInterviewTimeStr += this.timeList[index].label + ',';
          }
        }
        if (showInterviewTimeStr.length > 0) {
          showInterviewTimeStr = showInterviewTimeStr.substring(0, showInterviewTimeStr.length - 1);
          if (showInterviewTimeStr.indexOf('今天') >= 0) {
            if (showInterviewTimeStr.length > 5) {
              showInterviewTimeStr = showInterviewTimeStr.substring(0, 5) + '..';
            }
          } else if (showInterviewTimeStr.indexOf('明天') >= 0) {
            if (showInterviewTimeStr.length > 5) {
              showInterviewTimeStr = showInterviewTimeStr.substring(0, 5) + '..';
            }
          } else {
            if (showInterviewTimeStr.length > 5) {
              showInterviewTimeStr = showInterviewTimeStr.substring(0, 5) + '..';
            }
          }
        }
        let showTimeTip = '';
        for (let index = 0; index < 4; index++) {
          if (this.workTimeTypeList.indexOf(index + '') >= 0) {
            showTimeTip += this.workTimes[index] + ',';
          }
        }
        if (showTimeTip.length > 0) {
          showTimeTip = showTimeTip.substring(0, showTimeTip.length - 1);
          if (showTimeTip.length > 3) {
            showTimeTip = showTimeTip.substring(0, 2) + '..';
          }
        }
        let positionClassShowNameTips = '';
        if (this.positionClassNameList && this.positionClassNameList.length > 0) {
          positionClassShowNameTips = this.positionClassNameList.join(',');
          if (positionClassShowNameTips.length > 2) {
            positionClassShowNameTips = positionClassShowNameTips.substring(0, 2) + '..';
          }
        }
        // 行业展开后的岗位ID与手动选择的岗位ID去重
        pcts = [...new Set(pcts)];
        this.$emit('search', {
          ContractAddressList: this.contractAddressList,
          // PositionTypeList: this.positionTypeList,
          ExperienceList: this.experienceList,
          WorkTimeTypeList: this.workTimeTypeList,
          PositionClassSysNoList: pcts,
          PositionTagClassNameList: this.positionTagClassNameList,
          PositionTagIdList: this.positionTagIdList,
          UserGenderList: this.userGenderList,
          AgeList: ageList,
          WeekDayList: this.weekdayList,
          UserGenderName: this.userGenderName,
          ShowInterviewTimeStr: showInterviewTimeStr,
          ShowTimeTip: showTimeTip,
          PositionClassShowNameTips: positionClassShowNameTips
        });
        this.show = false;
      },
      setWelfare(data) {
        console.log(JSON.stringify(data));
        this.tagClassNameList = [...data.nameList]; // 显示用
        this.positionTagClassNameList = [...data.nameList];
        this.positionTagIdList = [...data.idList];
      },
      search(arr) {
        this.show = true;
        console.log(JSON.stringify(arr));
        this.classNameList = [...arr.PositionClassShowList]; // 显示用
        this.positionClassNameList = [...arr.PositionClassShowList];
        this.positionClassSynNoList = [...arr.PositionClassSysNoList];
      },
      callPositionPopup() {
        this.$emit('callPositionPopup', {});
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/css/theme.less';
  .home-per{max-height: calc(100vh - 90px);overflow-y:auto;}
  .home-per /deep/.van-cell, .home-per /deep/.van-collapse-item__content{background: @white;font-size:12px;}
  .home-per /deep/.van-collapse-item__content{padding:0 15px;}
  .popup-del{ padding: 10px 0 5px 15px;}
  .drawline {
    height: 1px;
    width: 100%;
  }
  .ds-partime-list p{
    width: 22.75%;
    margin: 0 3% 10px 0;
    box-sizing: border-box;
    height:35px;
    line-height:36px;
    font-size: 14px;
  }
  .ds-partime-list p:nth-child(4n+4){
    margin: 0;
  }

  .fringe /deep/.van-cell__value--alone {
    color: #666;
  }

  // /deep/.van-hairline--top-bottom::after {
  //   border-width: 0;
  // }
</style>
